<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';

export default {
  name: 'WebinarAddon',
  mixins: [base, planCommon],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === planTypes.WEBINAR && !p.isOneMonth),
        ['participants', 'amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>
